import loading from './loading'
import intersection from './intersection'
import clickOutside from './click-outside'

export default [
	loading,
	intersection,
	clickOutside
]
